import cn from "classnames";
import type { RateIssueCode, RateRecord } from "./rates.model";
import { countByStatus } from "./rates.model";

const ISSUE_ROWS: { code: RateIssueCode; label: string }[] = [
  { code: "validity", label: "Missing Validity" },
  { code: "charges", label: "Charges Unclear" },
  { code: "equip", label: "Missing Equipment" },
  { code: "routing", label: "Routing Unclear" },
  { code: "dup", label: "Conflicting Rates" },
  { code: "expired", label: "Expired Rates" },
];

export type RatesParseMeta = {
  parsing: boolean;
  parsed: boolean;
  fixed: RateIssueCode[];
};

type RatesParsingSummaryProps = {
  rates: RateRecord[];
  meta: RatesParseMeta;
};

export const RatesParsingSummary = ({ rates, meta }: RatesParsingSummaryProps) => {
  const { parsing, parsed, fixed } = meta;
  const counts = countByStatus(rates);
  const fixedSet = new Set(fixed);
  const remainingIssues = rates.reduce((total, rate) => total + rate.issueCodes.length, 0);
  const issueCount = (code: RateIssueCode) =>
    rates.filter((rate) => rate.issueCodes.includes(code) && rate.status === "review").length;
  const show = parsed || parsing;

  return (
    <aside className="pcx rt-ai__side">
      <div className="rt-chk__hd">
        <div className="pcx__h">Parsing Summary</div>
        {/* <span className="rt-chk__c">{parsing ? "Parsing…" : parsed ? "Parsing complete" : "Waiting for file"}</span> */}
      </div>
      <div className="rt-sum">
        <div className="rt-s">
          <b>{show ? rates.length : "—"}</b>
          <span>Total Rates</span>
        </div>
        <div className="rt-s rt-s--ok">
          <b>{show ? counts.ready : "—"}</b>
          <span>Clean Rates</span>
        </div>
        <div className="rt-s rt-s--warn">
          <b>{show ? counts.rejected : "—"}</b>
          <span>Rejected</span>
        </div>
        <div className="rt-s rt-s--iss">
          <b>{show ? remainingIssues : "—"}</b>
          <span>Issues Found</span>
        </div>
      </div>
      {show && (
        <>
          <div className="rt-iss">
            <div className="rt-iss__h">Issues Breakdown</div>
            <ul>
              {ISSUE_ROWS.map(({ code, label }) => (
                <li key={code} className={cn({ "is-fixed": fixedSet.has(code) })}>
                  <span>{label}</span>
                  <em>{fixedSet.has(code) ? 0 : issueCount(code)}</em>
                </li>
              ))}
            </ul>
          </div>
          <div className="rt-leg">
            <div className="rt-iss__h">Rate status</div>
            <div className="rt-leg__r">
              <span className="rt-st rt-st--ok">Clean Rates</span>
              <em>{counts.ready}</em>
            </div>
            <div className="rt-leg__r">
              <span className="rt-st rt-st--warn">Needs Information</span>
              <em>{counts.review}</em>
            </div>
            <div className="rt-leg__r">
              <span className="rt-st rt-st--con">Conflict</span>
              <em>0</em>
            </div>
            <div className="rt-leg__r">
              <span className="rt-st rt-st--exp">Expired</span>
              <em>0</em>
            </div>
          </div>
        </>
      )}
    </aside>
  );
};
